module.exports = __webpack_public_path__ + "img/rs.e4159b1.svg";